import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Grid, IconButton, Dialog, DialogContent, DialogTitle, Button, Paper, } from "@mui/material";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useTQuery } from "../../utils/useTQuery";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";


const formatDate = (date) => dayjs(date).format("DD MMMM, YYYY");

const JobDetails = () => {
    const { jobId, clinicianId } = useParams();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const { data } = useTQuery(
        ["clinicianJobsDetails", jobId, clinicianId],
        `/job/getJobDetailByJobUserId?${new URLSearchParams({ jobId, clinicianId }).toString()}`,
        'get'
    );
    const result = data?.OUTPUT || [];
    const jobDetails = result[0]?.job;
    const onJobs = () => {
        navigate(`/clinician/jobs`)
    }
    const onBack = () => {
        navigate(-1);
    }
    if (result.length === 0) {
        return <p>Loading...</p>
    }
    return (
        <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
            <IconButton
                aria-label="back"
                onClick={onBack}
                sx={{ position: "absolute", top: 8, left: 8, zIndex: 10 }}
            >
                <ArrowBackIcon />
            </IconButton>
            <IconButton
                aria-label="back"
                onClick={onBack}
                sx={{ position: "absolute", top: 8, right: 8, zIndex: 10 }}
            >
                <HomeIcon />
            </IconButton>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 2,
                    overflowY: "auto",
                    maxHeight: "100vh",
                }}
            >

                <Card sx={{ maxWidth: "90%", marginBottom: 2, width: "100%" }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Job Details
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Hiring By:</Typography>
                                <Typography>{result[0].hiringBy}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Work Type:</Typography>
                                <Typography>{result[0].workType}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Pay Rate:</Typography>
                                <Typography>{result[0].clinicianPayRate}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Applicant Status:</Typography>
                                <Typography>{result[0].clinicianStatus}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Offer Status:</Typography>
                                <Typography>{result[0].offerStatus}</Typography>
                            </Grid>


                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Service Date:</Typography>
                                <Typography>{formatDate(jobDetails.SERVICE_DATE)}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Service End Date:</Typography>
                                <Typography>{formatDate(jobDetails.SERVICE_END_DATE)}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Job Type:</Typography>
                                <Typography>{jobDetails.JOB_TYPE}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Facility Name:</Typography>
                                <Typography>{jobDetails.user.FACILITY_NAME}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Facility Address:</Typography>
                                <Typography>{jobDetails.user.STREET_ADDRESS}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Recruiter Name:</Typography>
                                <Typography>{jobDetails.user.FULL_NAME}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Recruiter Phone Number:</Typography>
                                <Typography>{jobDetails.user.PHONE_NUMBER}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" fontWeight="bold">Recruiter Email Address:</Typography>
                                <Typography>{jobDetails.user.EMAIL_ADDRESS}</Typography>
                            </Grid>
                            <Box display="flex" alignItems="center" px={2} pt={1.2}>
                                <Typography
                                    variant="h4"
                                    style={{
                                        fontWeight: 500,
                                        fontSize: "16px",
                                        color: "#000000",
                                        opacity: "87%",
                                    }}>
                                    Working Days:
                                </Typography>
                                <Button onClick={() => setOpen(true)}>Job Service (Date & Time)</Button>
                            </Box>
                        </Grid>
                        {open && <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                            <DialogTitle>
                                Job Services
                                <IconButton
                                    aria-label="close"
                                    onClick={() => setOpen(false)}
                                    sx={{
                                        position: "absolute",
                                        right: 8,
                                        top: 8,
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <Box display="flex" flexDirection="column" gap={2}>

                                    {jobDetails?.job_services?.length > 0 ? (
                                        jobDetails.job_services
                                            .sort((a, b) => new Date(a.JOB_DATE) - new Date(b.JOB_DATE)) // Sorting by JOB_DATE
                                            .map((service) => (
                                                <Paper key={service.ID} sx={{ p: 2 }}>
                                                    <Typography><strong>Date:</strong> {new Date(service.JOB_DATE).toDateString()}</Typography>
                                                    <Typography><strong>In Time:</strong> {service.JOB_IN_TIME}</Typography>
                                                    <Typography><strong>Out Time:</strong> {service.JOB_OUT_TIME}</Typography>
                                                </Paper>
                                            ))
                                    ) : (
                                        <Typography>No job services available.</Typography>
                                    )}

                                </Box>
                            </DialogContent>
                        </Dialog>}
                    </CardContent>
                </Card>
            </Box>
        </Box>

    );
};

export default JobDetails;
